// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__13tNP","errorLogs":"EditorFooter_errorLogs__3Ios6"};